import React from "react";
import "./index.css";

// ========================================
// RANK ENTRY COMPONENT - FOR INDIVIDUAL RANKS
// ========================================
// This component displays a single rank entry with icon, title, tag, and description
// It's used by the RankCategory component to display each rank in a category
//
// PROPS YOU CAN EDIT:
// - icon: The emoji or symbol for the rank (e.g., "★", "🦅", "||")
// - title: The rank title (e.g., "[07] Brigadier General")
// - tag: Object with text and className (e.g., { text: "Staff role" } or { text: "Veteran", className: "veteran" })
// - description: The description text for the rank
//
// TO ADD A NEW RANK:
// 1. Go to src/pages/Ranks/index.js
// 2. Find the rankCategories array
// 3. Add a new rank object to the appropriate category
// 4. Include: icon, title, tag (optional), description
//
// TO CHANGE TAG COLORS:
// 1. Go to src/components/RankEntry/index.css
// 2. Edit the .rank-tag, .rank-tag.veteran, or .rank-tag.recruit classes
// 3. Change the background-color property

const RankEntry = ({ icon, title, tag, description }) => {
  return (
    <div className="rank-entry">
      {/* LEFT COLUMN: Icon, Title, and Tag (40% width) */}
      <div className="rank-left-column">
        {/* RANK ICON - Change the icon prop to use different symbols */}
        <div className="rank-icon">{icon}</div>

        {/* RANK TITLE - Change the title prop to update the rank name */}
        <div className="rank-title">{title}</div>

        {/* RANK TAG - Only shows if tag prop is provided */}
        {tag && (
          <div className="rank-tags">
            <span className={`rank-tag ${tag.className || ""}`}>
              {tag.text}
            </span>
          </div>
        )}
      </div>

      {/* RIGHT COLUMN: Description (60% width) */}
      <div className="rank-right-column">
        {/* RANK DESCRIPTION - Change the description prop to update the text */}
        <div className="rank-desc">{description}</div>
      </div>
    </div>
  );
};

export default RankEntry;
